import { render, staticRenderFns } from "./DynamicRegisterDropdown.vue?vue&type=template&id=30b05af8"
import script from "./DynamicRegisterDropdown.vue?vue&type=script&lang=js"
export * from "./DynamicRegisterDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports